export interface IMenuItem {
  label: string;
  icon: string;
  url: string;
  /**
   * Extra route prefixes that also count as "this item is active". routerLinkActive
   * only matches under `url`, so an item whose section spans sibling routes (the
   * assets list and graph) lists the others here.
   */
  alsoActiveOn?: string[];
}

export interface IMenuListItem {
  groupName?: string;
  children: IMenuItem[];
}

export const MENU_ITEMS: IMenuListItem[] = [
  {
    groupName: '',
    children: [
      {
        label: 'Dashboard',
        icon: 'icon-grid-01',
        url: '/dashboard',
      },
      {
        label: 'Security Posture',
        icon: 'icon-line-chart-up-02',
        url: '/security-posture',
      },
    ],
  },
  {
    groupName: 'EXPOSURE',
    children: [
      {
        label: 'Assets',
        icon: 'icon-server-01',
        // List is the entry point; the graph is the secondary view.
        url: '/exposure/assets-list',
        alsoActiveOn: ['/exposure/assets'],
      },
      {
        label: 'Vendors',
        icon: 'icon-building-07',
        url: '/exposure/vendors',
      },
      {
        label: 'Accounts',
        icon: 'icon-users-02',
        url: '/exposure/accounts',
      },
      {
        label: 'Early Warnings',
        icon: 'icon-alert-triangle-fit',
        url: '/exposure/early-warnings',
      },
    ],
  },
  {
    groupName: 'RISK MANAGEMENT',
    children: [
      {
        label: 'Risk Register',
        icon: 'icon-file-02',
        url: '/risks/register',
      },
      {
        label: 'Risk Library',
        icon: 'icon-library',
        url: '/risks/library',
      },
      {
        label: 'Vulnerabilities',
        icon: 'icon-shield-zap',
        url: '/vulnerabilities',
      },
      {
        label: 'Compliance',
        icon: 'icon-check-verified-01',
        url: '/compliance',
      },
    ],
  },
  {
    groupName: 'SECURITY OPERATIONS',
    children: [
      {
        label: 'My Tasks',
        icon: 'icon-clipboard-check',
        url: '/my-tasks',
      },
      {
        label: 'Pentesting',
        icon: 'icon-lock-01',
        url: '/pentesting/request',
      },
    ],
  },
];

export const PROFILE_ITEMS: IMenuItem[] = [
  {
    label: 'Integrations',
    icon: 'icon-integrations',
    url: '/integrations',
  },
  // Hidden for now, not removed — the notifications pages and their routes are still
  // in place, so restoring the entry is a matter of uncommenting this.
  // {
  //   label: 'Notifications',
  //   icon: 'icon-notifications',
  //   url: '/notifications/all',
  // },
  {
    label: 'Settings',
    icon: 'icon-setings',
    url: '/settings',
  },
];
